import {swiper, swiperSlide} from 'vue-awesome-swiper';

const INDICATOR_CLASS = '.pro01-promo__slide-status-indicator';
const INDICATOR_ANIMATION_CLASS = 'pro01-promo__slide-status-indicator--animate';

function startAnimation() {
	this.indicators = document.querySelectorAll(INDICATOR_CLASS); // when looping, this needs to be reselected
	for (let i = 0; i < this.indicators.length; i++) {
		this.indicators[i].classList.add(INDICATOR_ANIMATION_CLASS);
		this.indicators[i].style.animationDuration = this.duration / 1000 + 's';
	}
}

function stopAnimation() {
	this.indicators = document.querySelectorAll(INDICATOR_CLASS);
	for (let i = 0; i < this.indicators.length; i++) {
		this.indicators[i].classList.remove(INDICATOR_ANIMATION_CLASS);
	}
}

let pro01Promo = {
	components: {
		swiper,
		swiperSlide
	},
	data() {
		return {
			doAutoSlide: true,
			indicators: [],
			notNextTick: true,
			pro01PromoOption: null,
			isOnlyOneItem: false
		};
	},
	computed: {
		getWindowWidth() {
			return window.width;
		}
	},
	methods: {
		calculateAutoSlide() {
			this.doAutoSlide = this.slideCount > 1;
		},
		calculatePromoOption() {
			this.pro01PromoOption = {
				autoplay: this.doAutoSlide ? {delay: this.duration} || false : false,
				autoplayDisableOnInteraction: false,
				loop: this.doAutoSlide,
				simulateTouch: this.doAutoSlide,
				allowSwipeToNext: this.doAutoSlide,
				allowSwipeToPrev: this.doAutoSlide,
				slidesPerView: 'auto',
				width: 1300,
				on: {
					init: startAnimation.bind(this),
					slideChangeTransitionEnd: startAnimation.bind(this),
					slideChangeTransitionStart: stopAnimation.bind(this),
					touchEnd: startAnimation.bind(this),
					touchStart: stopAnimation.bind(this)
				},
				breakpoints: {
					1170: {
						width: this.getWindowWidth
					},
					767: {
						width: this.getWindowWidth,
						autoHeight: true
					}
				},
				navigation: {
					nextEl: this.nextButton || null,
					prevEl: this.prevButton || null
				},
				pagination: {
					el: this.pagination || null,
					clickable: true
				},
				mousewheel: false
			};
		}
	},
	props: [
		'moduleId',
		'duration',
		'nextButton',
		'prevButton',
		'pagination',
		'slideCount'
	],
	beforeMount() {
		let slides = document.querySelectorAll(`.pro01-promo.${this.moduleId} .swiper-container .swiper-slide`);
		// ezt azért created-ben kell megtenni, mert később már újabb elemek kerülnek a dom-ba
		this.isOnlyOneItem = slides && slides.length === 1;
	},
	mounted() {
		this.calculateAutoSlide();
		this.calculatePromoOption();
	}
};

export default pro01Promo;



// WEBPACK FOOTER //
// ../source/modules/PRO01-promo/PRO01-promo.js